module.exports = __webpack_public_path__ + "static/media/tamtam.c2abeed8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/tamtam.ttf?cciqt6
// module id = 657
// module chunks = 0